<template>
	<div>
		<div class="pro_c_item_m">
			<div class="pro_c_r_m">
				<ul>
					<li
						v-for="(item, index) in dataArr"
						:key="item.id"
						@click="() => goDetail(item)"
						:style="{ visibility: item.show ? 'hidden' : '' }"
					>
						<img
							:src="item.bd_coverpicturecn"
							alt="专用软件"
						/>
						<p>{{ item.bd_titlecn }}</p>
					</li>
				</ul>
			</div>
		</div>
		<div class="pro_c_r">
			<ul>
				<li
					v-for="(item, index) in dataArr"
					:key="item.bd_atpid"
					@click="() => goDetail(item)"
					:style="{ visibility: item.show ? 'hidden' : '' }"
				>
					<div class="imgBox">
						<img
							:src="item.bd_coverpicturecn"
							alt="专用软件"
							v-show="!item.img"
						/>
					</div>
					
					<p>{{ item.bd_titlecn }}</p>
				</li>
			</ul>
		</div>
		<router-view />
	</div>
</template>

<script>
import Axios from 'axios'
export default {
	data() {
		return {
			dataArr: [],
			paramsId: '',
			itemArr: [],
			array:[]
		}
	},
	watch: {
		$route() {
			this.paramsId = this.$route.params.id
		},
		paramsId() {
			this.init()
		},
	},
	mounted() {
		this.init()
	},
	methods: {
		async init() {
			await Axios({
				url: '/apiv2/bdoctree/gettree?bdContenttype=%E4%BA%A7%E5%93%81%E4%B8%AD%E5%BF%83',
			}).then((res) => {
				this.recFun(res.data.data)
				Axios({
					url:'/apiv2/bdoctree/getalllist?bdContenttype=产品中心',
				}).then((res) => {
					this.dataArr = []
					for(var i=0;i<res.data.data.rows.length;i++){
						res.data.data.rows[i].bd_coverpicturecn=res.data.data.rows[i].bd_coverpicturecn
						this.array.push(res.data.data.rows[i])
					}
					this.itemArr.child.map((item) =>
						res.data.data.rows.filter((val) => {
							if (item.id === val.bd_atpid) {
								this.dataArr.push(val)
								new Set(this.dataArr)
							}
						})
					)

					switch (this.dataArr.length % 4) {
						case 1:
							this.dataArr = [
								...this.dataArr,
								{
									bd_atpid: new Date().getTime() + Math.random() * 0.5,
									bd_titlecn: '',
									img: true,
									show: true,
								},
								{
									bd_atpid: new Date().getTime() + Math.random() * 0.5,
									bd_titlecn: '',
									img: true,
									show: true,
								},
								{
									bd_atpid: new Date().getTime() + Math.random() * 0.5,
									bd_titlecn: '',
									img: true,
									show: true,
								},
							]

							break

						case 2:
							return (this.dataArr = [
								...this.dataArr,
								{
									bd_atpid: new Date().getTime() + Math.random() * 0.5,
									bd_titlecn: '',
									img: true,
									show: true,
								},
								{
									bd_atpid: new Date().getTime() + Math.random() * 0.5,
									bd_titlecn: '',
									img: true,
									show: true,
								},
							])
							break
						case 3:
							return (this.dataArr = [
								...this.dataArr,
								{
									bd_atpid: new Date().getTime() + Math.random() * 0.5,
									bd_titlecn: '',
									img: true,
									show: true,
								},
							])
							break
						default:
							break
					}
				})
			})
		},
		recFun(arr) {
			if (!arr instanceof Object) {
				return
			} else {
				arr.map((item) => {
					if (item.child.length > 0) {
						this.recFun(item.child)
						if (item.id === this.$route.params.id) {
							this.itemArr = item
						}
					}
				})
			}
		},
		goDetail(item) {
			let isTarget = this.itemArr.child.filter((val) => {
				return val.name === item.bd_titlecn
			})
			if (!isTarget[0].child.length) {
				this.$router.push('/product/profile/' + item.bd_atpid)
			} else {
				this.$router.push('/product/productdetail/' + item.bd_atpid)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@media (min-width: 1200px) {
	@import '../../style/base.scss';
	@import './index.scss';
}
@media (max-width: 1199px) {
	@import '../../style/mb.scss';
	@import './m-index.scss';
}
</style>